export const getVideoPlacementStyles = () => ({
  placementCard: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  videoPlayerVertical: {
    height: '520px',
    width: '300px',
    padding: '10px',
    borderRadius: 10,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  videoPlayerRoot: {
    height: '100%',
    width: '100%',
    display: 'flex',
    padding: '20px',
    justifyContent: 'center',
    alignItems: 'center',
  },
});
